module.exports = __webpack_public_path__ + "img/fr_Ecran 5.7f52c42d.png";